import store from "@/store"

let inited = false;
export function setZendeskAutoHide() {
  if(inited) {
    return
  }
  inited = true;
  const $el = document.getElementById('launcher')
  $el && $el.classList.add('ze-move-show')
  // setTimeout(() => $el.classList.remove('ze-move-show'), 4000)
}

export default function zendeskShow() {
  let user = store.state.user
  if (window.zE) {
    // zendesk 预填用户信息
    window.zE('webWidget', 'prefill', {
      name: {
        value: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : ''
      },
      email: {
        value: user.email || ''
      }
    })
    window.zE('webWidget', 'show')
    window.zE('webWidget', 'open')
  }
}
